<template>
  <v-dialog
    :key="account.id"
    v-model="show"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-container>
        <v-card-title
          v-if="!account.id"
          class="headline px-0"
        >
          New Account
        </v-card-title>
        <v-card-text class="px-2">
          <v-form
            id="form_register"
            ref="form"
            v-model="isValid"
            lazy-validation
          >
            <v-flex>
              <v-text-field
                id="register_name"
                ref="acc_name"
                v-model="account.name"
                append-icon="mdi-account-box"
                name="account_Name"
                :rules="accountNameRules"
                label="Account Name*"
                type="text"
                autofocus
                required
                :error-messages="getError('Name')"
                @mouseup="dirtyError('Name')"
              />

              <v-text-field
                id="register_firstName"
                v-model="account.firstName"
                append-icon="mdi-account"
                name="firstName"
                label="First Name*"
                :rules="firstNameRules"
                type="text "
                required
                :error-messages="getError('FirstName')"
                @mouseup="dirtyError('FirstName')"
              />

              <v-text-field
                id="register_lastName"
                v-model="account.lastName"
                append-icon="mdi-account"
                name="lastName"
                label="Last Name*"
                :rules="lastNameRules"
                type="text "
                required
                :error-messages="getError('LastName')"
                @mouseup="dirtyError('LastName')"
              />

              <v-text-field
                id="register_emailId"
                v-model="account.emailID"
                append-icon="mdi-mail"
                name="emailId"
                label="E-mailID*"
                :rules="emailRules"
                required
                :error-messages="getError('EmailID')"
                @mouseup="dirtyError('EmailID')"
              />

              <v-text-field
                id="register_password"
                v-model="account.password"
                append-icon="mdi-lock"
                name="password"
                label="Password*"
                :rules="passwordRules"
                type="password"
                required
                hint="Password must be 6 to 12 characters"
                :error-messages="getError('Password')"
                @keyup.enter.native="onSubmit(register)"
                @mouseup="dirtyError('Password')"
              />

              <v-autocomplete
                id="register_country"
                v-model="account.countryID"
                :rules="countryRules"
                :items="countries"
                item-text="name"
                item-value="id"
                label="Country*"
                clearable
                open-on-clear
              />

              <v-autocomplete
                id="register_timeZone"
                v-model="account.timeZone"
                :items="timeZones"
                item-text="timeZoneType"
                item-value="timeZoneLoc"
                label="Time zone*"
                :rules="timeZoneRules"
                clearable
              />
            </v-flex>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div>
            <small style="font-weight:400;margin-right: 4px;">
              *indicates required field</small>
          </div>
          <v-spacer />
          <v-btn
            id="register_close"
            color="error"
            class="white--text"
            @click.native="close()"
          >
            Close
          </v-btn>
          <v-btn
            id="register_save"
            color="success"
            class="white--text"
            :disabled="!isValid "
            :loading="loader"
            @click.native="insert()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
	name: "AccountRegister",
	props: {
		showDialog: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isValid: false,
			loader: false,
			account: {
				name: "",
				firstName: "",
				lastName: "",
				emailID: "",
				password: "",
				timeZone: "",
				countryID: null,
				applicationID: null
			},
			countries: [],
			timeZones: [],
			errors: {},
			accountNameRules: [
				v => !!v || "Account name is required",
				v =>
					(v && v.length <= 50) || "AccountName must be less than 50 characters"
			],
			firstNameRules: [
				v => !!v || "First name is required",
				v =>
					(v && v.length <= 25) || "First name must be less than 25 characters"
			],
			lastNameRules: [
				v => !!v || "Last name is required",
				v =>
					(v && v.length <= 25) || "Last name must be less than 25 characters"
			],
			passwordRules: [
				v => !!v || "Password is required",
				v =>
					(v && v.length >= 6 && v.length <= 12) ||
                    "Password must be 6 to 12 characters"
			],
			emailRules: [
				v => !!v || "E-mail is required",
				v =>
					/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/.test(
						v
					) || "E-mail must be valid"
			],
			countryRules: [v => !!v || "Country is required"],
			timeZoneRules: [v => !!v || "Time Zone is required"]
		};
	},
	computed: {
		show() {
			return this.showDialog;
		}
	},
	watch: {
		show(v) {
			if (v) {
				this.applicationID = JSON.parse(
					localStorage.getItem("login_user")
				).applicationID;
				this.getCountries();
				this.getTimeZone();
				this.account.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			}
		},
		"account.countryID": function(newCountryID) {
			if (newCountryID) {
				const selectedCountry = this.countries.find(c => c.id === newCountryID);
				if (selectedCountry && selectedCountry.timeZoneLoc) {
					this.account.timeZone = selectedCountry.timeZoneLoc;
				}
			}
		}
	},
	methods: {
		close() {
			this.$emit("update:showDialog", false);
			this.$emit("refresh");
		},
		insert: function () {
			if (!this.$refs.form.validate()) {
				return;
			}
			this.account.applicationID = this.applicationID;
			this.loader = true;
			this.$http.post(`${this.BO_API_URL}/register`, this.account).then(
				function (data) {
					this.loader = false;
					this.close();
					this.$store.commit("showSnackbar", {
						timeout: 3000,
						message: data.body.message
					});
				},
				function (failure) {
					this.loader = false;
					this.handleFailure(failure);
				}
			);
		},
		getError(key) {
			return this.errors && this.errors[key] ? [this.errors[key]] : [];
		},
		dirtyError(key) {
			this.errors[key] = "";
		},
		handleFailure: function (failure) {
			let msg = failure.body.message || "Error";
			let errors = failure.body.errors;
			if (errors && errors.Name) {
				msg = errors.Name;
			}
			if (errors && errors.EmailID) {
				msg = errors.EmailID;
			}
			this.$store.commit("showSnackbar", {
				message: msg,
				color: "error"
			});
		},
		getCountries: function () {
			this.$http.get(`${this.ADMIN_API_URL}/countries`).then(function (data) {
				this.countries = data.body;
			});
		},
		getTimeZone: function () {
			this.$http.get(`${this.ADMIN_API_URL}/timezones`).then(
				function (data) {
					this.timeZones = data.body;
				},
				function (failure) {
					this.handleFailure(failure);
				}
			);
		},
		clear() {
			this.errors = {};
			this.$refs.form.reset();
		}
	}
};
</script>